<template>
  <b-modal
    id="select-sorting-bucket"
    title="Select Bucket for Sorting Operation"
    hide-footer
    centered
    :static="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    visible
  >
    <b-form @submit.prevent="confirmSelection">
      <b-form-group label="Sorting Date">
        <b-form-datepicker
          :value="today"
          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
          placeholder="YYYY-MM-DD"
          disabled
        />
      </b-form-group>
      <b-form-group label="Sorting Category">
        <b-form-input
          value="Night Operations"
          disabled
        />
      </b-form-group>
      <b-form-group label="Select Bucket">
        <b-form-select
          v-model="selectedBucket"
          :options="bucketOptions"
          value-field="value"
          text-field="text"
          required
        />
      </b-form-group>
      <b-form-group
        v-if="selectedBucket"
        label="Sorting ID"
      >
        <b-form-input
          :value="sortingIdPreview"
          disabled
        />
      </b-form-group>
      <div class="d-flex justify-content-center">
        <b-button
          variant="primary"
          type="submit"
          :disabled="!selectedBucket || isStarting"
        >
          <span v-if="isStarting">
            Starting...
          </span>
          <span v-else>
            Start Sort
          </span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'SelectSortingBucketOverlay',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormDatepicker,
  },
  props: {
    bucketOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      today: new Date().toISOString().split('T')[0], // Format: yyyy-mm-dd
      selectedBucket: '',
      isStarting: false,
    }
  },
  computed: {
    selectedBucketObj() {
      // Find the selected bucket object
      return this.bucketOptions.find(
        bucket => bucket.value === this.selectedBucket,
      )
    },
    sortingIdPreview() {
      const bucketName = this.selectedBucketObj
        ? this.selectedBucketObj.name.replace(/\s+/g, '-')
        : ''
      // Generate sorting ID based on bucket name and date
      return this.selectedBucket
        ? `${this.today}-Night-Ops-${bucketName}`
        : `${this.today}-Night-Ops`
    },
  },
  methods: {
    confirmSelection() {
      this.isStarting = true
      const longDate = new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
      this.$emit('confirmed', {
        date: longDate,
        bucket: this.selectedBucket,
        bucketName: this.selectedBucketObj ? this.selectedBucketObj.name : '',
        sortingId: this.sortingIdPreview,
      })
    },
  },
}
</script>
